// extracted by mini-css-extract-plugin
export default {"container":"Indicator_container__hOjLS","icon-wrapper":"Indicator_icon-wrapper__Y-HuP","text-wrapper":"Indicator_text-wrapper__ufAY4"};